var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    className: "cls-1",
    d: "M9.375,10.156A1.561,1.561,0,0,0,7.813,8.594H7.031a3.125,3.125,0,0,0-3.125,3.125v2.344a3.125,3.125,0,0,0,3.125,3.125h.781a1.561,1.561,0,0,0,1.563-1.562Zm8.594,7.031a3.122,3.122,0,0,0,3.125-3.125V11.719a3.122,3.122,0,0,0-3.125-3.125h-.781a1.561,1.561,0,0,0-1.562,1.563v5.469a1.561,1.561,0,0,0,1.563,1.563ZM12.5,0A12.738,12.738,0,0,0,0,12.5v.781a.784.784,0,0,0,.781.781h.781a.784.784,0,0,0,.781-.781V12.5a10.156,10.156,0,0,1,20.313,0h0c0,.117,0,8.091,0,8.091a2.063,2.063,0,0,1-2.065,2.065H15.625a2.344,2.344,0,0,0-2.344-2.344H11.719a2.344,2.344,0,0,0,0,4.688h8.872A4.407,4.407,0,0,0,25,20.591V12.5A12.738,12.738,0,0,0,12.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.4a9a458b89f1827bc72e0122ab17acba.svg";
export { ForwardRef as ReactComponent };